export default {
  language: '请选择语言',
  terms: '条款 · 隐私权政策',
  Disclaimers: '免责声明与风险提示',
  annualized: '平均年化56.74%，累计收益163.15%。',
  drawdown: '平均年化87.43%，累计收益145.72%',
  college:'衍泰学院',
  web3:'衍泰WEB3',
  home: {
    attention: '注意：为保障资产安全，聊天场景中严禁透露钱包地址、私钥等敏感信息',
    EmailInput: '请输入您的邮箱',
    TechnicalSupport: '技术支持',
    emailFormat: '请输入正确的邮箱格式',
    contact: '联系我们',
    title: '矩阵力量',
    banner_desc: '让每一位投资者都可以享受到顶尖AI量化策略带来的前景',
    banner_highlight: '量化交易+AI智能',
    banner_future: '驱动行业交易未来',
    discover: '发现更多 →',
    about: '常见问题',
    explore: '开始探索',
    schematicDiagram: '近两年示意图',
    dataModule: {
      funds: "资金由",
      exchange: '顶级服务商托管 ',
      description: '完全符合美国监管规定，客户资产完全隔离。通过MPC和HSM实现多层保护，并获得SOC 2 Type II认证',
      scale: '衍泰平台策略服务资金规模已达到',
      StrategicPlan: '策略方案',
      yieldRate: '预估年化收益率',
      strategy: '随时随地，从您的交易策略中获得回报',
      // return: '',
      advantage: '强大的量化策略结合MatrixPower的安全与保障，带来极致的体验。'
    },
    carousel: {
      hedge: '跨所对冲',
      arbitrage: '套利策略',
      MarketPremise: '策略核心',
      MarketPremise_1: '同一标定物在不同交易所出现价差时通过不同手段稳定套利。',
      build: '策略亮点',
      build_1: '无惧市场涨跌，稳定获利。',
      mean: '价格均值回归',
      mean_1: '依赖均值回归逻辑，盈利来源为跨交易所价差',
      view: '查看更多 ',
      foreignExchange: '高频量化投资',
      arbitrage_1: '策略',
      collect: '策略核心',
      collect_1: '采集近10年全球主要外汇市场交易数据，通过AI统计大模型精准抓取超过30个影响外汇涨跌的显性因子，通过这些因子进行高频交易，获取超高额收益。',
      factor: '策略亮点',
      factor_1: '进行超高频交易，年回报率超过100%',
      combination: '因子组合策略优化',
      combination_1: '当高准确率因子组合发出明确信号时，自动交易'
    },
    card: {
      company_intro: '查看更多',
      discover: '发现更多',
      company_intro_one: '衍泰金融科技有限公司',
      ai_quant: 'AI量化',
      ai_quant_one: 'AI量化是以高效的交易程序代替傳统交易員的交...',
      app_download: 'APP下载',
      app_download_one: 'Matrix Power是一款通过ai量化技术帮助您实现...',
      app_matrix_desc: '矩阵力量APP是一款通过ai量化技术帮助您实现数字资产增值的服务管家。',
      contact_us: '联系我们',
      contact_us_one: '衍泰金融科技有限公司'
    },
    accordion: {
      title1: '公司介绍',
      content1: 'MP-稳赢项目是在提供专业的AI量化技术策略，团队成员均具备资深、专业的金融工程、IT、统计学背景。我们的目标是打破传统金融市场量化交易的高门槛，为有需要的投资者，以公平的方式分配利润，以透明的原则公开交易数据以及客户资产数据。',
      title2: '衍泰的使命',
      content2: '通过我们成熟的量化策略以及交易算法，帮助投资者在特定市场中进行7*24小时无间断的交易。同时，我们为了达到金融的普惠性质，亦为小客户提供托管资质。',
      title3: '衍泰的优势',
      content3: '稳定高收益，无市场风险。高收益的来源为MP-AI量化交易的优秀算法以及数字货币的高收益性，稳定年化可达60%，周度回报数据自团队2023年创办开始回撤基本为0，即没有亏损数据。并且我们的资产是托管在瑞士银行的独立账户内，如发生非市场风险，我们的托管资产由瑞士银行的信托保险全额赔付。',
      title4: '为什么选择衍泰',
      content4: '同业可分为传统基金机构与传统量化机构。相较于传统金融机构，我们的收益率是他们无法匹敌的，并且传统金融机构以扩大管理规模为目标，收取管理费，并不在乎投资者的收益情况。相较于传统的量化机构，他们的起投门槛至少为300~800万美元，普通投资者根本无法参与。需要特定私行或渠道才有机会参与传统的量化交易，并且收益率远不如我们的量化策略。',
      title5: '如何获利',
      content5: '我们的盈利模式为，我们的AI量化策略在设定好参数后，自动对Binance、Bybit、okx、Bitget交易所的前100市值的数字货币进行监测。如发现价差，我们高卖低买进行套利，最高每秒可进行30多次交易，完全由AI量化系统自动进行。因为是完全对冲，交易不受价格涨跌影响，买涨买跌都赚钱。'
    },
    partner: {
      title: '衍泰合作企业',
      subtitle: 'AI 量化策略将在知名交易所公开透明运作，交易全流程公开透明',
      slogan: '科技驱动，创新引领'
    },
    quant: {
      title: '衍泰量化',
      subtitle: '致力于以顶尖的AI技术，赋能量化交易模型，实现超额收益',
      leftTitle: '三大投资策略年化收益',
      leftDesc: '数字资产、外汇、A股期权三大量化策略模型独立运营，风险隔离，适配多种风险偏好',
      stat1: '外汇多因子交易模型',
      stat2: '跨所无风险套利模型',
      stat3: 'A股ETF期权套利',
      viewDetail: '查看详情',
      feeLabel: '技术服务费',
      securityTitle: '安全矩阵',
      sec1: '资金划转权限',
      sec1Val: '0',
      sec2: '双重风控拦截',
      sec2Val: '100%',
      sec3: '产品磨合期',
      sec3Val: '0天',
      sec4: '极致流动性',
      sec4Val: '7x24h'
    },
    service: {
      title: '服务规模',
      subtitle: '通过AI量化策略，持续为投资者带来稳定的资本增值，所有数据由第三方平台提供',
      item1: '高净值客户',
      num2: '7400万+',
      item2: '美元管理规模',
      num3: '3年+',
      item3: '业务无回撤'
    },
    aiSection: {
      title: '衍泰AI',
      subtitle: '衍泰AI驱动自主数字经济，AI创造价值、人类分享回报。',
      running: 'AI运行中',
      participants: '活跃人类参与者',
      targetApr: '目标年化',
      aiAgents: 'AI代理',
      aiGenerated: 'AI生成',
      engine: 'AI推广引擎',
      l1: '最新AI模型',
      l1v: '准确率',
      l2: '7×24小时全天候在线',
      l2v: '全天候在线',
      l3: '智能高效完成任务',
      l3v: '效率提高',
      l4: '企业级安全保障',
      l4v: '可靠率',
      productsTitle: '两大AI衍生产品',
      productsDesc: '衍泰AI开发较成熟，具备实际应用能力，用户可以通过使用目前的两大AI衍生品（AiGenNext、AI推广引擎）产生收益'
    },
    faqSubtitle: '解答您的疑虑，助您快速上手',
    fixed: {
      title: 'APP固收产品',
      subtitle: '旨在降低小资金的投资门槛，做到无风险、无封闭期的普惠金融',
      download: '前往下载',
      feat1: '起投金额：$1000',
      feat2: '平均年化：15%',
      feat3: '无封闭期'
    },
    notOpen: '暂未开放'
  },
  about: {
    titleName: '衍泰金融科技',
    titleName1: '关于我们',
    gs: '有限公司',
    qurMission: '我们的使命',
    company_profile: '衍泰金融科技有限公司(Matrix Power)是一家香港注册，在中国内地拥有独立数字版权的量化科技公司。核心研发团队均来自于国际顶尖大厂与投资银行。',
    team_intro: '我们的使命是致力于以顶尖的AI量化策略，打破传统金融市场的门槛，使得无论机构与个人投资者都可以最低成本的享受到AI量化策略带来的稳定增值。',
    slogan: '汇聚才智、打破壁量、共享未来',
    commitment: '是我们对每位投资者的承诺!',
    work: '除此之外，我们的所有工作都是',
    user: '以用户为中心,',
    safety: '用户保护为我们的第一要务。所以我们在Matrix Power系统中嵌入了最先进的安全措施和严格的数据隐私控制措施。',
    name: '衍泰金融科技有限公司',
    reason: '为何要选择',
    SimplifiedName: '衍泰量化',
    aiName: '衍泰AI',
    title1: 'AI量化业务',
    Department: {
      DepartmentName1: '科技运营部',
      DepartmentIntroduction1: '负责MatrixPower APP功能开发运营',
      DepartmentName2: '区块链科技技术研发部',
      DepartmentIntroduction2: '专注于RWA区块链技术开发',
      DepartmentName3: '量化投资研究部',
      DepartmentIntroduction3: 'AI量化策略开发',
      DepartmentName4: '国际事业部',
      DepartmentIntroduction4: '新加坡、越南、北非市场'
    },
    title2: '数字资产',
    prospect: {
      prospectName1: '多策略AI引擎',
      prospectHome1: '我们不依赖市场单一方向的涨跌。通过统计套利、市场中性、事件驱动、宏观对冲等多元化的量化模型，我们在全球所有大类资产市场中，系统性挖掘被错误定价的机会，剥离市场系统性风险，纯粹获取超额收益。',
      prospectName2: '尖端科技驱动',
      prospectHome2: '我们的策略根植于海量市场数据，依托自有超高算力与顶级的AI算法。通过高频的数据处理与模式识别，我们的系统能比传统方式更早、更精准地预见市场微小的非均衡性。      ',
      prospectName3: '严格的风险控制',
      prospectHome3: '风险控制是我们的第一信条。我们采用实时价值监控、多维度压力测试以及严格的止损与仓位管理机制，确保投资组合在面对极端行情时依然保持强韧性，将下行风险牢牢锁在笼中。      '
    }
  },
  quantify: {
    strategy: '我们的策略',
    arbitrage: '跨所对冲',
    StrategicCore:' 由于加密货币市场是去中心化且分散的，不同交易所之间可能因为流动性、用户需求、交易量或区域差异等原因，导致同一币种的价格出现偏差。该策略的核心在于：',
    StrategicCore_1:' 在价格较低的交易所买入某种数字货币。',
    StrategicCore_2:' 同时在价格较高的交易所卖出同等数量的该数字货币',
    StrategicCore_3:' 从这两个交易的价差中赚取利润。',
    StrategicCore_4:' 这种策略为超低风险套利形式，因为它不依赖于预测市场未来的整体走向，而是利用瞬时存在的市场低效性。',
    strategyCore1: "核心：利用跨交易所价差，做多低价、做空高价，对冲市场涨跌风险，稳赚固定价差收益",
    strategyName: "高频量化",
    collect: '数据采集',
    dataCollection: '显性因子的提取和筛选',
    content: "采集近10年全球主要外汇市场交易数据，覆盖不同经济周期（繁荣期、衰退期、复苏期），确保样本的完整性与代表性",
    screeningMethod: "采用贝叶斯信息准则（BIC）进行因子筛选，剔除相关性弱、解释力不足的变量。通过动态线性回归拟合，量化各因子对汇率变动的影响权重，最终提取出 ABCDEFG 等多个核心显性因子。经样本内回溯测试，入选因子的单独预测准确率均达到 90% 以上，确保因子的有效性与稳定性。",
    triggerCondition: "当高准确率因子组合发出明确信号时，判断外汇上涨概率为99.95%,此时向交易所自动发出交易指令。 ",
    strategyCore: "核心：基于多因子模型的精准决策体系",
    change: '了解我们如何为他人带来改变',
    experience: '听听我们的客户讲述与Matrix Power合作的经历，以及我们的投资策略如何帮助他们实现财务目标',
    defaultPanels: {
      title1: "Matrix Power彻底改变了我管理数字资产的方式。他们的AI量化策略帮助我的投资组合在过去的一年增长了45%，远超我的预期。",
      name1: "张明",
      label1: "科技创业者",
      belonging1: '未来科技有限公司',
      title2: "作为一名刚开始接触数字资产的投资者，Matrix Power的团队给了我很多宝贵的指导。他们的平台易于使用，策略简单明了，让我能够安心投资。",
      name2: "陈雅琳",
      label2: "数字资产爱好者",
      belonging2: '个人投资者',
      title3: "作为一名经验丰富的投资人，我对Matrix Power的专业水准印象深刻。他们的市场分析精准，风险管理策略完善，是值得信赖的合作伙伴。",
      name3: "李婷",
      label3: "资深投资人",
      belonging3: '全球投资集团',
      title4: "我向我的所有客户推荐Matrix Power。他们的服务透明度高，客户支持团队响应迅速，最重要的是，他们能够持续创造稳定的投资回报。",
      name4: "王建国",
      label4: "财务顾问",
      belonging4: '财富管理顾问公司',
    },





    user: {
      name_1: '张明',
      comment_1: 'Matrix Power彻底改变了我管理数字资产的方式。他们的AI量化策略帮助我的投资组合在过去的一年增长了45%，远超我的预期。',
      label_1: '科技创业者',
      origin_1: '未来科技有限公司',
      name_2: '李婷',
      comment_2: '作为一名经验丰富的投资人，我对Matrix Power的专业水准印象深刻。他们的市场分析精准，风险管理策略完善，是值得信赖的合作伙伴。',
      label_2: '资深投资人',
      origin_2: '全球投资集团',
      name_3: '王建国',
      comment_3: '我向我的所有客户推荐Matrix Power。他们的服务透明度高，客户支持团队响应迅速，最重要的是，他们能够持续创造稳定的投资回报。',
      label_3: '财务顾问',
      origin_3: '财富管理顾问公司',
      name_4: '陈雅琳',
      comment_4: '作为一名刚开始接触数字资产的投资者，Matrix Power的团队给了我很多宝贵的指导。他们的平台易于使用，策略简单明了，让我能够安心投资。',
      label_4: '数字资产爱好者',
      origin_4: '个人投资者',
    },

    attention: '联系我们',
    title: '什么是AI量化？',
    introduction: 'AI量化是以高效的交易程序代替传统交易员的交易职责。量化交易的本质是通过大数据及特定的统计模型，得到',
    winRate: '胜率最高',
    transaction: '的交易方案，并且自动执行。',
    transactionAdvantage: '相较于传统的人工交易，量化交易的优势在于，第一、交易不会受到人性的干扰，严格遵守交易纪律；第二、量化程序可高频交易，每秒几十次的交易是人工无法替代的；第三、AI量化程序不断收集市场数据，可改变参数应对市场变化。',
    Advantage: {
      name: 'AI量化业务',
      AdvantageTitle1: '专业资深的国际背景',
      introduction1: '衍泰金融的核心团队拥有顶尖的统计、IT、金融与风控背景，均拥有硕士以上学位。相较于投资收益，我们更加看重风险。确保每位参与者的资产稳定增值一直是我们的首要目标。',
      AdvantageTitle2: '充足的资金与严格的风控体系',
      introduction2: '衍泰金融拥有充足的资本金作为安全边际，每位参与者可随时查询。在技术层面，我们的AI量化风控系统7*24小时不断监测市场的风险指标，确保我们的交易永远在安全的量化指标内进行。',
      AdvantageTitle3: '高度数据透明与知名合作机构',
      introduction3: '衍泰的合作方均为世界级的机构托管团队与银行，确保投资数字资产安全以及透明度。',
      structureTitle: '策略、数据、代码展示',
      structureHome: '代码示范、仓位展示（3个APP页面截图）、AI量化交易框架、投资回报率对比',
      structureF: '发现更多 →'
    },
    plan: {
      title: '量化服务',
      planName1: '共赢集合计划',
      planName2: '稳赢专户计划',
      PlanHighlights: '计划亮点:',
      PlanHighlights1_1: '通过集成托管账户，使每个小投资者都可以参与AI量化投资，分享收益。',
      PlanHighlights1_2: '衍泰承诺不会对小资金与大资金进行区分，公平分配收益。每位投资者无论资金大小均可以查询后台数据。 ',
      PlanHighlights1_f: '发现更多',
      PlanHighlights2_1: '客户可自行开设托管账户，即不需要划转资金到第三方托管账户。',
      PlanHighlights2_2: '衍泰仅有子账户的投资权限，并无资金划转权限。',
      PlanHighlights2_3: '大资金专户在交易所手续费会有减免，可通过减少手续费的方式提升回报率。',
      PlanHighlights2_f: '注意:为保障现有投资者利益，本项目不定期开放募资，请联系投资顾问。'
    }
  },
  information: {
    name: '资讯中心',
    poster: '与趋势同行，一起慢慢变有钱',
    today: '今天',
    moon: '月',
    day: '日',
    Sunday: '周日',
    Monday: '周一',
    Tuesday: '周二',
    Wednesday: '周三',
    Thursday: '周四',
    Friday: '周五',
    Saturday: '周六',
    homePage: '首页',
    PreviousPage: '上一页',
    NextPage: '下一页',
    more: '了解更多'
  },
  contact: {
    HongKong: '香港',
    HongKong_1: '香港九龙大浦区通菜街111号云之端大厦5楼509室(总部)',
    Wuhan: '武汉',
    Wuhan_1: '湖北省武汉市江岸区中山大道平安金融中心7楼715室(办事处)',
    Changsha: '长沙',
    Changsha_1: '湖南省长沙市长沙县红树湾18栋18楼(办事处)',
    office: '联系我们',
    name: '联系我们',
    title: '客服全程协助，让沟通更省心',
    office_one: '我们的地址',
    service: ' 我们致力于为全球客户提供最优质的金融服务，为您的财富增值管理。欢迎垂询我们的产品与服务详情，欢迎您与我们联系。',
    formDesc: '客服全程协助，让沟通更省心，请告诉我们您面临的问题，以及我们该如何提供帮助，我们很乐意为您效劳。通常，我们会在几分钟内给予回复。',
    sendEmail: '发送邮件',
    companyAddress: '公司地址',
    yourEmail: '您的邮箱',
    yourName: '您的名字',
    yourQuestion: '您的问题',
    questionPlaceholder: '请在此输入需要我们解答的问题...',
    emailPlaceholder: '请输入邮箱',
    namePlaceholder: '请输入您的名字',
    submit: '提交',
    submitSuccess: '感谢您的留言，我们会尽快回复！'
  },
  agreement: {
    Disclaimers: '免责声明',
    rights: '2025 衍泰金融科技有限公司 保留一切权利',
    p1: '本报告由受香港特别行政区公司法监管的衍泰金融科技有限公司制作并于大中华地区分发。衍泰金融科技有限公司是由香港特别行政区注册的责任有限公司。',
    p2: '本报告并非针对或意图发送、发布给在当地法律或监管规则下不允许该报告发送、发布的人员。如有任何疑问，烦请向当地律师进行咨询。',
    p3: '本报告在任何地区均不应被视为交易任何证券或金融工具的邀约或邀请。',
    p4: '本网站所包含的观点及建议不适用于所有投资者，且并未考虑个别客户的特殊情况、目标或需要，不应被视为对特定客户关于特定证券或金融工具的建议或策略。',
    p5: '投资者不应以本网站取代其独立判断或仅依据本报告做出决策，并在需要时咨询专家意见。本报告所载的意见、观点及预测仅为本报告出具日分析师的观点和判断，相关证券或金融工具的价格、价值及收益亦可能会波动。',
    p6: '本报告中所引用的关于业绩的数据代表过往表现，过往的业绩表现并不能代表日后回报的预示。分析中所作的预测可能是基于相应的假设。任何假设的变化可能会显著地影响所预测的回报，该等意见、观点或预测无需通知即可随时更改。',
    p7: '衍泰金融科技有限公司的销售人员、交易人员及其他专业人士可能会依据不同假设和标准、采用不同的分析方法而口头或书面发表与本报告意见及建议不一致的市场评论及/或交易观点；衍泰金融科技有限公司的量化投资业务部门可能独立作出与本报告的意见或建议不一致的投资决策；衍泰金融科技有限公司没有将此意见及建议向报告所有接收者进行更新的义务。在不同时期，衍泰金融科技有限公司可能会发出与本报告所载意见、观点与预测不一致的报告。',
    p8: '本报告的资料来自于我们认为可靠的来源，但衍泰金融科技有限公司：(1) 不保证任何资料的准确性、完整性、时间性或是否可以使用；(2) 不对使用本报告内之材料产生的任何直接或间接或相关之损失承担任何责任。',
    p9: '衍泰金融科技有限公司：(1) 可能会持有本报告中所提到公司所发行的数字货币头寸并进行交易；(2) 可能在特定数字资产交易所进行做市活动或庄家活动。',
    p10: '本报告仅供意向收件人使用，未经衍泰金融科技有限公司事先书面授权，任何机构或人士不得翻印、复制、分发或传送本文件（无论整份和部分）给其他机构及/或人士。若经衍泰金融科技有限公司准许转发，转发人应获取独立的法律意见，以确定该转发符合当地适用法规的要求。衍泰金融科技有限公司及其雇员不为转发人及/或其客户因使用本报告或报告载明的内容产生的直接或间接损失承担任何责任。',
    name: '衍泰金融科技有限公司 香港特别行政区注册责任有限公司'
  },
  privacy: {
    privacy: '隐私政策',
    name1: '1. 我们收集的信息',
    title1: '当您使用Matrix Power量化服务时，我们可能收集以下信息:',
    p1_1: '账户信息：您注册时提供的姓名、联系方式、身份证明文件（用于合规验证）',
    p1_2: '交易信息：您的投资策略选择、资产配置、交易记录等量化服务相关数据',
    p1_3: '设备信息：访问设备的型号、IP地址、浏览器类型（用于安全风控）',
    name2: '2. 信息的使用方式',
    title2: '我们仅将收集的信息用于以下目的：',
    p2_1: '提供量化策略服务：基于您的投资偏好优化AI策略模型',
    p2_2: '合规与风控：遵守金融监管要求，防范交易风险',
    p2_3: '服务优化：分析用户行为以提升产品体验（匿名化处理后）',
    name3: '3. 信息的共享与披露',
    title3: '我们不会向第三方出售您的个人信息，仅在以下情况下共享：',
    p3_1: '获得您的明确授权时',
    p3_2: '遵守法律法规、响应司法机关合法请求时',
    p3_3: '与提供必要技术支持的合作方共享（需签署保密协议）',
    name4: '4. 信息的保护措施',
    title4: '我们采用符合金融行业标准的安全措施保护您的信息：',
    p4_1: '数据加密存储与传输',
    p4_2: '访问权限分级管控',
    p4_3: '定期安全审计与漏洞修复',
    name5: '5. 您的权利',
    title5: '您有权：',
    p5_1: '访问、更正您的个人信息',
    p5_2: '在符合条件的情况下删除您的账户信息',
    p5_3: '联系我们咨询隐私相关问题（support@matrixpower.com）',
    name6: '6. 协议的变更',
    title6: '我们可能会根据业务或监管要求更新本政策，变更后将在官网显著位置公告，若您继续使用服务则视为接受变更。',
    retain: '2025 Matrix Power 保留所有权利'
  },
  appDownload: {
    download: 'APP下载',
    butler: '您的一键式资本增长平台',
    title: '以顶尖的AI量化策略为投资者赋能，零风险享受每日稳健收益！',
    trust: '深受全球用户信赖',
    relyOn: '服务资产均在瑞银投保，杜绝非市场性风险，安享收益',
    establish: '成立于',
    user: '服务的用户',
    country: '服务范围',
    globalUsers:'全球用户',
    restriction:'(限制地区除外)',
    confirm: '请确认',
    prompt: '即将下载 MatrixPower App 安装包（apk格式），请确保设备允许未知来源应用安装',
    Cancel: '取消',
    download1: '确认下载',
    list: {
      header_1: '模块分区，让使用更简单',
      p1_1: '随时随地，让您更方便的投资',
      p1_2: '以数据驱动决策，多方面展示各数字币涨跌情况',
      header_2: '技术驱动，量化策略套餐矩阵',
      p2_1: '明确标注每个套餐的收益范围，每日获取收益，随存随取，共享收益！',
      p2_2: '多种投资套餐可选，投资更灵活。',
      header_3: '智能采集资讯，打破壁垒',
      p3_1: '通过NLP技术对全球数字资产市场的关键信息进行抓取，让客户实时掌握最新市场动向。',
      p3_2: '支持用户互动，构建积极的投资生态。',
      footList1: {
        Header1: '首页',
        title1: '活动预告',
        Header2: '功能',
        title2: '稳健收益',
        Header3: '资讯',
        title3: '最新热点',
      },
      footList2: {
        Header1: '基础',
        title1: 'AI量化技术',
        Header2: '亮点',
        title2: '稳定收益',
        Header3: '安全',
        title3: '保本保息',
      },
      footList3: {
        Header1: '跨平台',
        title1: '实时抓取',
        Header2: '量化',
        title2: '多次推送',
        Header3: '互动',
        title3: '点赞评论',
      },
    }
  },

  footer: {
    address: "湖北省武汉市江岸区中山大道平安金融中心7楼715室",
    nav: {
      contact: "联系我们",
      compliance: "合规资质",
      navigation: "导航",
      legal: "法律条款",
      academy: "行泰学院",
      about: "行泰量化",
      home: "首页",
      privacy: "隐私政策",
      terms: "服务条款",
      risk: "风险披露",
      followUs: "关注我们"
    },
    copyright: "©2026 MatrixPower",
    disclaimer: {
      p2: "服务受地域限制，部分国家/地区用户可能无法使用全部功能。",
      p1: "虚拟货币投资存在风险，过往收益不代表未来盈利。MatrixPower不对任何投资损失承担责任。"
    }
  },
  quantPage: {
    essence: {
      title1: '量化交易的',
      titleHl: '本质',
      desc: '利用数学模型、统计分析和计算机程序，从海量数据中寻找规律并自动执行交易指令的投资方式。它通过数据驱动决策，旨在排除人为情绪干扰，实现理性投资',
      trend: '预测走势',
      factor: '因子分析',
      auto: '自动交易'
    },
    strategy: {
      tag: '核心策略',
      title: '量化投资策略',
      subtitle: '通过AI模型算例优势，充分挖掘显性因子，不断提升交易胜率。',
      card1Title: '三大策略独立运作',
      card1Desc: '数字资产、外汇、期权三大策略线独立运营，独立风控，稳中求胜。',
      card2Title: '专业团队精细化管理',
      card2Desc: '每条策略线配备专属投研、风控团队，实时监控、动态调优',
      card3Title: '月度统计均正收益',
      card3Desc: '所有策略在月度统计中均取得正收益，业绩表现稳定'
    },
    matrix: {
      title: '产品矩阵',
      tab1: '外汇多因子交易',
      tab2: '跨所无风险套利',
      tab3: 'A股ETF期权拐点超高Alphal'
    },
    chart: {
      title: '平均收益率',
      subtitle: '基于近10年交易数据测试',
      annual: '年化收益率',
      monthly: '月化收益率',
      annualVal1: '71%',
      annualVal2: '24%',
      annualVal3: '104%',
      monthlyVal1: '5.19%',
      monthlyVal2: '2%',
      monthlyVal3: '8.67%',
      minInvest: '最低起投门槛',
      minInvestVal1: '$2.5万',
      minInvestVal2: '$2000万',
      minInvestVal3: '$100万',
      lossProb: '亏损概率',
      lossProbSub: '最大亏损率为10%'
    },
    p1: {
      title: '外汇多因子交易模型',
      subtitle: '多因子 AI 建模分析，智能执行高频外汇交易',
      f1: '采集近 10 年全球主流外汇市场完整交易数据',
      f2: 'AI 大模型抓取 30 + 涨跌显性因子，组合建模策略',
      f3: '自动化高频交易，依托显性因子自行开仓、平仓',
      f4: '强止损线为10%，严格风控'
    },
    p2: {
      title: '跨所无风险套利模型',
      subtitle: '捕捉同标的跨交易所价差，对冲实现稳定套利',
      f1: '衍泰兜底保障，亏损超1%由衍泰承担赔付',
      f2: '收益率参考历史数据预估',
      f3: '对冲套利模式，锁定价差收益'
    },
    p3: {
      title: 'A股ETF期权拐点超高Alphal',
      subtitle: '依托期权定价偏差/跨市场价差，构建对冲组合获取收益',
      f1: '预测指数日K拐点，判断月度方向',
      f2: '通过期权定价模型寻找错误定价',
      f3: '收获超高Alpha收益'
    },
    coop: {
      tag: '合作模式',
      title: '为什么选择衍泰量化?',
      c1Title: '资金安全保障',
      c1i1t: '资金物理隔离',
      c1i1d: '客户自行开户，衍泰仅获取API交易权，限绝无资金划转权限，确保本金绝对安全。',
      c1i2t: '双重风控拦截',
      c1i2d: '自研专业风控模型实时监控异常波动，将市场系统性风险和策略模型回撤风险降至行业最低水平。',
      c1i3t: '极致流动性保障',
      c1i3d: '全线产品均不设置封闭期，投资者可根据自身资金需求随时发起提款，确保资产的高流动性。',
      more1: '点击查看更多',
      c2Title: '全天候陪伴式辅导',
      c2i1t: '平台开户',
      c2i1d: '提供完善的平台开户指导，快速完成注册流程。',
      c2i2t: 'API绑定',
      c2i2d: '协助完成API接口绑定，确保交易顺畅运行。',
      c2i3t: '出入金操作',
      c2i3d: '资金进出自由，操作简单快捷，随时掌控账户资金。',
      more2: '点击查看更多',
      c3Title: '阳光分润机制',
      c3i1t: '透明分润流程',
      c3i1d: '每月1-3日统计上月盈利并发送对应账单给客户，客户核对账单后需要主动支付50%技术服务费。衍泰没有客户资产的划转权限，严格保护客户资产'
    },
    philo: {
      tag: '投资理念',
      title: '长期共赢 · 行稳致远',
      subtitle: '信任是金融世界的基石，透明是对投资者的承诺',
      card1Title: '资金容量管控',
      card1Desc: 'AI量化策略对资金容量高度敏感，衍泰通过不定期邀请制严格控制规模，保护现有客户收益',
      card2Title: '机构定位坚守',
      card2Desc: '坚守专业量化投资机构定位，只为客户取得合理的资本增值，坚守风控与合规底线',
      card3Title: '长期共赢生态',
      card3Desc: '与理念契合的合作伙伴建立跨越周期的长期共赢生态，追求长期稳定资本增值'
    },
    trust: {
      titlePre: '信任',
      titlePost: '是衍泰最宝贵的资产',
      title2: '行稳方能致远',
      btn: '立即加入'
    }
  },
  yantai: {
    heroHl: '衍泰AI',
    heroTitle: '给予未来无限可能',
    heroDesc: '衍泰作为最早一批深度训AI模型的公司，已拥有成熟的AI应用，包括量化交易辅助、AI推广引擎、AIgennext项目孵化器',
    heroBtn1: 'AI推广引擎',
    heroBtn2: 'AiGenNext',
    headerTitle: 'AI推广引擎',
    headerDesc: '通过AI模型，拟人化操作300-500个真实设备，自主搜索、发布、添加、回复，做到7*24流量推广',
    box1Title: '多设备统一管控',
    box1Desc: '多设备统一管控，高效统筹内容发布',
    box1Item1: '单后台批量管理海量设备，免去多端反复登录',
    box1Item2: '省去复制粘贴改格式繁琐步骤，深耕创意与策略',
    box1Item3: '兼容图文视频链接表情多类素材，适配各大平台',
    box1Item4: '贴合平台算法与用户偏好，差异化内容一键分发',
    panel1Name: '多设备统一管控',
    panel1Subtitle: '开启后批量管理海量设备，提高效率',
    panel1Add: '添加设备',
    panel1StatTotal: '设备总数',
    panel1StatOnline: '在线设备',
    panel1StatOffline: '离线设备',
    panel1StatStandby: '待机设备',
    panel1Search: '请输入设备名称/ID',
    panel1TagAll: '全部',
    panel1TagOnline: '在线',
    panel1TagOffline: '离线',
    panel1TagIdle: '空闲',
    panel1Batch: '批量操作',
    panel1BadgeMaster: '主控',
    panel1BadgeActive: '活跃',
    panel1BadgeStandby: '待机',
    panel1BadgeOffline: '离线',
    panel1DevId: 'ID: D-1024 最后活跃: 12:38',
    panel1StOnline: '在线',
    panel1StIdle: '空闲',
    panel1StOffline: '离线',
    box2Title: 'AI智能互动',
    box2Desc: '行业知识自动采集，AI赋能智能社交运营',
    box2Item1: '关键词识别、完成情绪分析、自动回复',
    box2Item2: '结合情感图分析，实现精准用户互动',
    box2Item3: '自动捕捉潜在用户',
    box2Item4: '助力品牌社交媒体运营更专业高效',
    panel2Name: 'AI智能互动',
    panel2Subtitle: '自动回复、自动捕捉潜在用户',
    auto: '自动',
    p2c1Name: 'AI评论自动回复',
    p2c1Desc: '感谢您的支持！更多详情请关注主页 👇',
    p2c2Name: 'AI私信自动回复',
    p2c2Desc: '“您好，请问有什么可以帮到您的？”',
    p2c3Name: 'AI自动改写',
    p2c3Desc: '已针对 TikTok/Ins 生成差异化版本文案',
    p2c4Name: 'AI监控回复',
    p2c4Desc: '已自动回复 5 条正面提及',
    p2c5Name: '关键词识别',
    p2c5Desc: '实时抓取行业热点，完成情绪分析',
    p2c6Name: '潜在用户捕捉',
    p2c6Desc: '自动识别意向用户，提升客户转化效率',
    p2c7Name: '智能运营助手',
    p2c7Desc: '助力品牌社交媒体运营更专业高效',
    p2s1: '今日互动总量',
    p2s1Unit: '次',
    p2s1Trend: '较昨日 +12%',
    p2s2: '节省运营成本',
    p2s2Unit: '小时',
    p2s2Trend: '自动处理87%常规咨询',
    p2s3: '自动回复数量',
    p2s3Unit: '条',
    p2s3Trend: '私信12·评论35',
    p2s4: '潜在用户捕捉',
    p2s4Unit: '人',
    p2s4Trend: '今日新增意向用户',
    box3Title: 'AI一键产出素材',
    box3Desc: '一句话下达需求，AI一站式生成处理内容',
    box3Item1: '一句话输入需求，AI自动生成图片、视频',
    box3Item2: '自动适配各平台尺寸，支持一键多语言翻译',
    box3Item3: '素材文案自动归档入库，直达发布编辑器',
    box3Item4: '支持定时发送，降低团队运营成本',
    panel3Name: 'AI 素材创作',
    panel3Subtitle: '视频、图片、文章',
    styleTitle: '风格模型',
    more: '更多',
    styleRealistic: '写实',
    styleIllustration: '插画',
    style3D: '3D',
    styleCinematic: '电影感',
    styleWatercolor: '水彩',
    styleCyber: '赛博',
    p3Ph1: '上传参考图、输入文字，',
    p3Ph2: '描述你想生成的图片',
    p3Generate: '生成',
    p3Save: '保存设计',
    box4Title: '7×24小时在线',
    box4Desc: '7×24 小时全天候值守，安全守护品牌运营',
    box4Item1: '7×24小时在线，智能高效执行各类任务',
    box4Item2: '提供企业级安全防护保障',
    box4Item3: '全自动全天候处理，重要信息零遗漏',
    box4Item4: '即时响应用户，持续守护品牌形象',
    agHead1: 'Web3',
    agHead2: '到AI',
    agHead3: '的进化',
    agDesc: 'Aigennext是基于衍泰AI的一个孵化项目，核心理念是：“AI创造价值，人类共享收益”',
    agBtn: '开始探索'
  },
  aboutPage: {
    heroPre: '量化交易+',
    heroHl: 'AI智能',
    heroSub: '复合型公司',
    heroTagline: '" 汇聚财智 · 行稳致远 · 共享未来 "',
    coDesc: '以香港为总部，武汉、长沙为分布的跨区域的金融科技机构，核心团队均来自国际顶尖大厂与投资银行',
    statFounded: '成立年份',
    statScale: '美元 服务规模',
    statAlgo: '算法自主',
    tag1: '持牌合规',
    tag2: '自研算法',
    tag3: '全球视野',
    advTitle: '衍泰的优势',
    advSubtitle: '衍泰拥有前沿的AI智能体开发技术，团队专业背景深厚、量化研究经验丰富，让您的选择更有保障',
    tab1: 'AI智能体',
    tab2: '精干核心团队',
    tab3: '严格的风险控制',
    a1l1h: '自主研发',
    a1l1r: 'AI大模型',
    a1l2r: '高频交易获取',
    a1l2h: '超额收益',
    a1l3r: '精准抓取超',
    a1l3m: '个',
    a1l3b: '显性因子',
    a2l1h: '15+',
    a2l1r: '精英团队',
    a2l2h: '90%',
    a2l2r: '以上硕士/博士',
    a2l3r: '量化研究',
    a2l3h: '经验丰富',
    a2l4: '技术底蕴深厚',
    a3l1h: '实时',
    a3l1r: '价值监控',
    a3l2h: '多维度',
    a3l2r: '压力测试',
    a3l3h: '严格',
    a3l3r: '的止损与仓位',
    a3l4: '管理机制',
    visionTitle: '公司愿景',
    visionDesc1: '以智能重新定义量化、以量化赋能智能，成为',
    visionDesc2: '全球领先的AI驱动型资产管理机构'
  },
  appd: {
    servedUsers: '服务12000+',
    usersLabel: '全球(限制地区除外)用户',
    trustDesc: 'MatrixPower APP深受全球用户信赖，提供资产托管和智能配置，杜绝非市场性风险，安享收益',
    statRegion: '交易地区',
    statDownloads: '下载量',
    statRating: '用户评分',
    statPositive: '好评率',
    f1t: '模块分区',
    f1d: '理财计划、社区资讯实时同步，数据智能分析，全天候监控交易状态，提供最优投资策略',
    f2t: '技术驱动',
    f2d: '前沿的AI量化策略算法，超99%的识别率，自动执行，风控体系完善，投资更安全',
    f3t: '交易透明',
    f3d: '实时资金监控，确保资金流转安全透明，区块链加密存储，确保用户资产安全',
    f4t: '技术支持',
    f4d: '提供7x24小时专业服务，快速响应机制保障交易顺畅，确保用户问题及时处理',
    secSubtitle: '机构级安全保障，合规监管透明可查，通过KFC和AML实现多层防护，并获得SOC2 TypeII认证',
    assetTitle: '客户资产保障',
    assetL1: '资产分仓存储',
    assetL2: 'APP内资产冷存储',
    assetL3: '数字资产安全隔离',
    tagPrincipal: '本金绝对安全',
    tagSelfOpen: '自行开户',
    dualL1: '活体专业风控团队实时监控智能预警',
    dualL2: 'SOC 2 Type II认证',
    tagRiskModel: '自研风控模型',
    transTitle: '交易透明机制',
    transL1: '全链路交易数据可查',
    transL2: '智能防篡改加密',
    transL3: '实时对账，按秒刷新，一天可多次查看',
    tagRealtime: '实时可查',
    tagLiquid: '高流动性',
    ctaDesc: '服务资产均在链上投保，杜绝非市场性风险，安享收益'
  },
}